import { imageServiceBaseUrl } from './image-service';
export const defaultCoreConfig = {
  modernImagesBaseUrl: imageServiceBaseUrl.production
};